<ng-container *transloco="let t">
  @if (!medias().length) {
    <div class="h-full w-full">
      <h5 class="m-0 text-center">
        {{ t("media-input.no_media_found") }}
      </h5>
    </div>
  }
  @if (medias().length > 0) {
    <div class="flex items-center gap-2 p-2">
      <div iInputGroup class="min-w-0 flex-1">
        <IIcon name="search" />
        <input
          iInputGroupInput
          [placeholder]="t('media-input.search_by_filename')"
          [(ngModel)]="mediaNameFilter"
          name="mediaName"
        />
      </div>
      @if (hasImageSizeFilter()) {
        <ISelectMenu
          class="w-40 shrink-0"
          popoverWidth="160"
          [value]="selectedImageSize()"
          (valueChange)="selectedImageSize.set($event)"
        >
          <ISelectTrigger size="sm">
            <ISelectValue [placeholder]="t('media-input.filter_by_size')">
              <div *iSelectValue="let size" class="flex items-center gap-1">
                <button
                  iButton
                  type="button"
                  variant="ghost"
                  size="xs"
                  class="p-0"
                  [iTooltip]="t('filter-tags.clear_filter')"
                  (click)="clearImageSizeFilter($event)"
                >
                  <IIcon name="close" />
                </button>
                <span>{{ size.label }}</span>
              </div>
            </ISelectValue>
          </ISelectTrigger>
          <ISelectContent>
            @for (size of imageSizeFilterValues(); track size) {
              <ISelectOption [value]="size">{{ size.label }}</ISelectOption>
            }
          </ISelectContent>
        </ISelectMenu>
      }
    </div>
    @if (filteredMedias().length === 0) {
      <div class="mt-4 flex justify-center text-center font-medium text-gray-800">
        {{ t("media-input.no_matching_file") }}
      </div>
    }
  }

  <div class="grid flex-auto grid-cols-2 gap-2 p-2" data-testid="media-cards">
    @for (m of filteredMedias(); track m) {
      <app-media-card
        [media]="m"
        [mediaType]="mediaType()"
        [isSelected]="selectedMedia()?.assetId === m.assetId"
        (click)="setSelectedMedia(m)"
        class="h-[20rem]"
      />
    }
  </div>
</ng-container>
